import axios from 'axios'
import moment from 'moment'
import { get } from '../helpers/FetchHelper'
import { getLocalStorage } from '../helpers/LocalStorage'
import helper from '../helpers/Variables'
import { getSearch } from './ClubeApi'

const baseUrl = process.env.REACT_APP_API_CLUB_URL
const headers = {
  Authorization:
    getLocalStorage(helper.TOKEN_KEY) !== null
      ? `Bearer ${getLocalStorage(helper.TOKEN_KEY)}`
      : null
}

export const getProductsList = async () => {
  try {
    const url = `${baseUrl}get/clippingProducts`
    const res = await get(url, { headers })
    return res
  } catch (e) {
    console.log('error', e)
    return null
  }
}

export const getPartnersClippingList = async (
  page = null,
  limit = null,
  userGroup = null
) => {
  try {
    if (userGroup === 4) {
      const url = `${baseUrl}get/clippingList`
      const res = await get(url, { headers })
      return res
    }
    const url = `${baseUrl}get/clipping/${page}/${limit}/${userGroup}`

    const res = await get(url, { headers })
    return res
  } catch (e) {
    console.log('error', e)
    return null
  }
}

export const getPartnersClippingListByPartner = async (
  page = null,
  limit = null,
  userGroup = null
) => {
  try {
    if (userGroup !== 4) {
      const res = await getPartnersClippingList(page, limit, userGroup)
      const remodeled = (res.data || []).reduce((accumulative, current) => {
        const others = accumulative.filter(({ partner }) => partner.id !== current.partnerId)
        const needed = accumulative.find(({ partner }) => partner.id === current.partnerId) || {
          partner: current.Partner,
          clippings: []
        }
        needed.clippings.push(current)
        return [...others, needed]
      }, [])
      return {
        data: remodeled,
        pagination: res.pagination
      }
    }
    const res = await getPartnersClippingList(null,null,userGroup)
    const remodeled = (res || []).reduce((accumulative, current) => {
      const others = accumulative.filter(({ partner }) => partner.id !== current.partnerId)
      const needed = accumulative.find(({ partner }) => partner.id === current.partnerId) || {
        partner: current.Partner,
        clippings: []
      }
      needed.clippings.push(current)
      return [...others, needed]
    }, [])

    return {
      data: remodeled,
      pagination: null
    }
  } catch (e) {
    console.log('error', e)
    return null
  }
}

export const createClipping = async body => {
  try {
    const url = `${baseUrl}create/clipping`
    const res = await axios.post(url, body, { headers })
    return res.data
  } catch (e) {
    return { error: e }
  }
}

export const searchClipping = async (type, value, userGroup = null) => {
  try {
    const res = await getSearch(type, value, (userGroup = null))
    const remodeled = (res || []).reduce((accumulative, current) => {
      const others = accumulative.filter(({ partner }) => partner.id !== current.partnerId)
      const needed = accumulative.find(({ partner }) => partner.id === current.partnerId) || {
        partner: current.Partner,
        clippings: []
      }
      needed.clippings.push(current)
      return [...others, needed].sort((one, another) => moment(another.date).diff(one.date))
    }, [])
    const sorted = remodeled.sort((one, another) =>
      one.partner.fantasyName.localeCompare(another.partner.fantasyName)
    )
    return sorted
  } catch (e) {
    console.log('error', e)
    return null
  }
}
